import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import BlockingSpinnerOverlay from 'components/BlockingSpinnerOverlay';
import HStreamIDField from 'components/fields/HStreamIDField';
import { Button, Form, FormGroup } from 'reactstrap';
import LabelWithLoginInformationTooltip from '../../components/Utilities/LabelWithInformationTooltip';

const tooltipContent = [
    <>
        Best Option! If you use your mobile number to login, entering your <strong>Mobile Number</strong> here is the fastest way to get your password reset.
    </>
];

const ResetPasswordForm = ({ isRequestPending, handleSubmit, onSubmit }) => (
    <Form
        className="position-relative"
        aria-busy={isRequestPending}
        onSubmit={handleSubmit((values) => {
            if (isRequestPending) return;
            return onSubmit(values);
        })}
    >
        <BlockingSpinnerOverlay show={isRequestPending} ariaLabel="Loading..." />
        <HStreamIDField
            required
            helpText=""
            id="forgot_pw_input"
            label={(
                <LabelWithLoginInformationTooltip
                    labelText="Mobile Number or Email"
                    tooltipId="forgot_password"
                    tooltipContent={tooltipContent}
                />
            )}
            name="hstreamid"
            disabled={isRequestPending}
        />
        <FormGroup>
            <Button block disabled={isRequestPending} color="primary">
                Send Reset Link
            </Button>
        </FormGroup>
    </Form>
);

ResetPasswordForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isRequestPending: PropTypes.bool,
};

ResetPasswordForm.defaultProps = {
    isRequestPending: false,
};

const ConnectedResetPasswordForm = reduxForm({
    // form: 'forgot-account',
    form: 'forgot-password',
})(ResetPasswordForm);

export default ConnectedResetPasswordForm;
export { ResetPasswordForm as PureResetPasswordForm };
